import { router } from './router'
// import store from './store'
// import { ElMessage } from 'element-plus'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, setToken } from '@/utils/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

// const whiteList = ['/login', '/dashboard', '/dashboard1', '/dashboard2'] // no redirect whitelist
const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  // Token Patch，解决跨项目登录跳转问题
  const tokenPatch = to.query.token_patch
  if (tokenPatch) {
    setToken(tokenPatch)
  }

  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    next()
    NProgress.done() // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
  } else {
    /* has no token */
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
      NProgress.done()
    } else if(to.path === 'dashboard'){
      // other pages that do not have permission to access are redirected to the login page.
      // next(`/login?redirect=${to.path}`)
      next(`/manager`) 
      NProgress.done()
    }else{
      next()
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
